function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 2483",
  width: 41,
  height: 41,
  rx: 6,
  fill: "rgba(0,0,0,0)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 20v-8.646L18 10v10zm11 0h13V8L19 9.807zm-1 1H8v7.646L18 30v-9zm1 0v9.194L32 32V21z",
  fill: "#c0c3d5"
});

var SvgWindows = function SvgWindows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 42 \\u2013 1",
    width: 41,
    height: 41
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkNvbXBvbmVudCA0MiDigJMgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNDEiIGhlaWdodD0iNDEiPjxyZWN0IGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDI0ODMiIHdpZHRoPSI0MSIgaGVpZ2h0PSI0MSIgcng9IjYiIGZpbGw9InJnYmEoMCwwLDAsMCkiLz48cGF0aCBkPSJNOCAyMHYtOC42NDZMMTggMTB2MTB6bTExIDBoMTNWOEwxOSA5LjgwN3ptLTEgMUg4djcuNjQ2TDE4IDMwdi05em0xIDB2OS4xOTRMMzIgMzJWMjF6IiBmaWxsPSIjYzBjM2Q1Ii8+PC9zdmc+";
export { SvgWindows as ReactComponent };